// validationSchema.ts
import * as yup from "yup";

export const serviceDespesaSchema = yup.object().shape({
  date_from: yup
    .string()
    .nullable()
    .default(null)
    .test(
      "is-valid-date-range",
      "A data inicial não pode ser maior que a data final.",
      function (value) {
        const { date_to } = this.parent; // Acessa o valor de date_to
        if (!value || !date_to) return true; // Ignora validação se uma das datas estiver ausente
        return new Date(value) <= new Date(date_to); // Valida que date_from <= date_to
      }
    )
    .test(
      "both-or-none",
      "Se preencher uma data, ambas as datas devem ser preenchidas.",
      function (value) {
        const { date_to } = this.parent; // Acessa o valor de date_to
        // Verifica se ambos os campos estão preenchidos ou ambos estão vazios
        return (!value && !date_to) || (value && date_to);
      }
    ),
  date_to: yup
    .string()
    .nullable()
    .default(null)
    .test(
      "both-or-none",
      "Se preencher uma data, ambas as datas devem ser preenchidas.",
      function (value) {
        const { date_from } = this.parent; // Acessa o valor de date_from
        // Verifica se ambos os campos estão preenchidos ou ambos estão vazios
        return (!value && !date_from) || (value && date_from);
      }
    ),
  ids: yup
    .array(yup.number().required()) // Garante que os números sejam obrigatórios
    .nullable()
    .default(null),
  add_days: yup
    .number()
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    )
    .default(null),
});
